import script from "./EditTgModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./EditTgModal.vue?vue&type=script&setup=true&lang=ts"

import "./EditTgModal.vue?vue&type=style&index=0&id=651625fc&lang=css"

const __exports__ = script;

export default __exports__